import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@icc/ui';
import { ComplaintAppointment } from '@icc/b2b/shared';

@Component({
    selector: 'icc-complaint-appointment-protocol-email-send',
    templateUrl: './complaint-appointment-protocol-email-send.component.html',
    styleUrls: ['./complaint-appointment-protocol-email-send.component.scss'],
})
export class ComplaintAppointmentProtocolEmailSendComponent {

    constructor(
        private dialogRef: DialogRef,
        @Inject(DIALOG_DATA)
        public data: {
            appointment: ComplaintAppointment
        },
    ) {}

    sendEmail() {
        this.dialogRef.close(this.data.appointment);
    }

    close() {
        this.dialogRef.close();
    }
}
